import axiosInstance from "./axiosInstance";

export const getFooter = async (locale = "en") => {

  const res = await axiosInstance.get(
    `/api/footers?locale=${locale}`
  );

  return res.data.data[0];
};